import type { ValueOrCondition } from '@unifyapps/defs/types/conditionalValueFilters';
import type { LCColorValue } from '@unifyapps/defs/types/styleObject';
import { getConditionalPropertyValue } from '../../../utils/conditionalValues';

export const getColorValue = (color?: ValueOrCondition<LCColorValue>) => {
  const computedColor = getConditionalPropertyValue<LCColorValue>({
    value: color,
  });

  if (typeof computedColor === 'object') {
    return computedColor.custom;
  }

  return computedColor;
};
